import { useCallback, useEffect, useMemo, useState } from "react";
import BalanceSheet from "../../fragments/balance-sheet";
import { useCalculateCustomerBudgetQuery, useGetAssignmentsQuery, useGetCustomerQuery } from "../../../../api/plamo-api";
import dayjs from "dayjs";
import { Select } from "antd";


const CustomerLoaded = ({ customerId, onCustomerLoaded, onCustomerRemoved }) => {
  const { data: customer } = useGetCustomerQuery({ id: customerId });

  useEffect(() => {
    if(customer) {
      onCustomerLoaded(customer);
    }

    return () => { onCustomerRemoved(customer) }
  }, [customer, onCustomerLoaded, onCustomerRemoved])

  return <></>
}

const BudgetLoaded = ({ year, customerId, onBudgetLoaded, onBudgetRemoved }) => {
  const { data: budget } = useCalculateCustomerBudgetQuery({ id: customerId, year }) as any;

  useEffect(() => {
    if(budget) {
      onBudgetLoaded(customerId, budget);
    }

    return () => { onBudgetRemoved(customerId) }
  }, [budget, onBudgetLoaded, onBudgetRemoved, customerId])

  return <></>
}

function EmployeeBalanceSheet({ employeeId }) {
  const [year, setYear] = useState<number>(dayjs().year());
  const [customers, setCustomers] = useState<any>([]);
  const [budgets, setBudgets] = useState<any>({});
  const { data: assignments } = useGetAssignmentsQuery({ f: JSON.stringify({ "employee.id": { c: "EQ", v: employeeId }}), st: JSON.stringify({ "employee.lastName": "desc" }) }, { skip: !employeeId }) as any;
  const filteredAssigments = useMemo(() => assignments?.items?.filter(a => (!a.startDate || dayjs(a.startDate).valueOf() < dayjs().valueOf()) && (!a.endDate || dayjs(a.endDate).valueOf() > dayjs().valueOf())), [assignments])
  
  const onCustomerLoaded = useCallback((customer) => {
    setCustomers(currentCustomers => [...currentCustomers, customer]);
  }, [setCustomers])

  const onCustomerRemoved = useCallback((customer) => {
    setCustomers(currentCustomers => currentCustomers.filter(c => c !== customer));
  }, [setCustomers])

  const onBudgetLoaded = useCallback((customerId, budget) => {
    setBudgets(currentBudgets => ({...currentBudgets, [customerId]: budget}));
  }, [setBudgets])

  const onBudgetRemoved = useCallback((customerId) => {
    setBudgets(currentBudgets => ({...currentBudgets, [customerId]: undefined}));
  }, [setBudgets])
  
  return <>
    <Select options={[{ label: "2025", value: "2025" }, { label: "2026", value: "2026"}]} value={year} onChange={value => setYear(Number(value))} />
    <BalanceSheet customers={customers} budgets={budgets} year={year} />
    {
      filteredAssigments?.map(a => <CustomerLoaded customerId={a.customerId} onCustomerLoaded={onCustomerLoaded} onCustomerRemoved={onCustomerRemoved} />)
    }
    {
      filteredAssigments?.map(a => <BudgetLoaded year={year} customerId={a.customerId} onBudgetLoaded={onBudgetLoaded} onBudgetRemoved={onBudgetRemoved} />)
    }
  </>
}

export default EmployeeBalanceSheet;